/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import block from 'bem-cn';

import SVG from 'components/SVG';
import Switcher from 'components/Switcher';

import { actions } from 'features/users/redux';
import detailsSVG from 'features/users/img/details.svg';
import dropdownSVG from 'features/users/img/dropdown.svg';
import { formatProviderNames } from 'shared/helpers';

import { isProviderBlocked, permissionsDetailsData, providerNameReplaceMap } from '../../../../../data';

import './PermissionsDetailsItems.scss';

const b = block('permissions-details-items-desktop ');

const PermissionsDetailsItems = ({ item, userId, userInfo, permissionsForAgent, setPermissionsForAgent }) => {
  const dispatch = useDispatch();
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { bannedProviders, semiAutoWithdrawalEnabled } = useSelector(state => state.users);

  const [categoryOpen, setCategoryOpen] = useState(
    permissionsDetailsData.reduce((acc, curr) => ((acc[curr.category] = false), acc), {}),
  );

  const checkIsEqual = array => {
    const filteredArray = bannedProviders?.filter(item => array.includes(item));

    return array.length === filteredArray?.length;
  };

  const findCategory = item =>
    permissionsDetailsData.filter(categoryItem => categoryItem.items.includes(item))[0].category;

  const handleSetProviderState = data => dispatch(actions.setBannedProviders({ data: { ...data, semiAutoWithdrawalEnabled } }));

  const providersListWithReplacedNames = item.items.map(item => providerNameReplaceMap?.[item] ?? item);

  return (
    <div className={b()} key={item.category}>
      <div className={b('item')}>
        <div className={b('item-container')}>
          <SVG
            onClick={() => setCategoryOpen({ ...categoryOpen, [item.category]: !categoryOpen[item.category] })}
            containerClassName={b('item-dropdown')}
            svgProps={{ svg: dropdownSVG }}
          />
          <div className={b('item-title')}>{locale[item.category]}</div>
        </div>
        <div className={b('item-container')}>
          <div className={b('item-switcher')}>
            <Switcher
              isActive={!checkIsEqual(providersListWithReplacedNames)}
              onSwitch={() =>
                handleSetProviderState({
                  providers: providersListWithReplacedNames,
                  action: checkIsEqual(providersListWithReplacedNames) ? 'remove' : 'add',
                  isFullBranch: true,
                  id: userId,
                  category: item.category,
                })
              }
            />
          </div>
          <>
            {userInfo.role !== '0' && (
              <SVG
                onClick={() => {
                  setPermissionsForAgent({
                    ...permissionsForAgent,
                    isOpen: true,
                    category: item.category,
                    enabled: !checkIsEqual(providersListWithReplacedNames),
                    items: providersListWithReplacedNames,
                    isChildItem: false,
                  })
                }

                }
                containerClassName={b('item-details')}
                svgProps={{ svg: detailsSVG }}
              />
            )}
          </>
        </div>
      </div>
      {categoryOpen[item.category] &&
        item.items.map(item => {
          return (
            <div key={item} className={b('item', { inner: true })}>
              <div className={b('item-container')}>
                <div className={b('item-title', { inner: true })}>{formatProviderNames[item]}</div>
              </div>
              <div className={b('item-container')}>
                <div className={b('item-switcher')}>
                  <Switcher
                    isActive={!isProviderBlocked(bannedProviders, item)}
                    onSwitch={() =>
                      handleSetProviderState({
                        providers: [providerNameReplaceMap?.[item] ?? item],
                        action: isProviderBlocked(bannedProviders, item) ? 'remove' : 'add',
                        isFullBranch: true,
                        id: userId,
                        category: findCategory(item),
                      })
                    }
                  />
                </div>
                {userInfo.role !== '0' && (
                  <SVG
                    onClick={() =>
                      setPermissionsForAgent({
                        ...permissionsForAgent,
                        isOpen: true,
                        category: providerNameReplaceMap?.[item] ?? item,
                        enabled: !isProviderBlocked(bannedProviders, item),
                        items: [providerNameReplaceMap?.[item] ?? item],
                        isChildItem: true,
                      })
                    }
                    containerClassName={b('item-details')}
                    svgProps={{ svg: detailsSVG }}
                  />
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PermissionsDetailsItems;
